module.exports = __webpack_public_path__ + "static/media/un.9c879c82.svg";